import React from 'react';
import { NavLink } from 'react-router-dom';
import DonateButton from '../donateButton/default';

const Header = () => {
  return (
  
    
  <><div className="header">
      <div className="inner-header">
        <div className='logo'>
          <img src='/images/Logo.png' alt='OCD New York' />
        </div>
        <div className='nav'>
          <div className='social'>
            <a href='https://www.facebook.com/ocdny/'><img src='/images/fb.jpg' alt='OCD New York' /></a>
            <a href='https://www.instagram.com/ocdny/'><img src='/images/insta.jpg' alt='OCD New York' /></a>
          </div>
          <ul>
            <li><NavLink exact className={({ isActive }) => isActive ? 'current' : ''} to='/'>Home</NavLink></li>
            <li><NavLink exact className={({ isActive }) => isActive ? 'current' : ''} to='/about'>About Us</NavLink></li>
            <li><NavLink exact className={({ isActive }) => isActive ? 'current' : ''} to='/events'>Events</NavLink></li>
            <li><NavLink exact className={({ isActive }) => isActive ? 'current' : ''} to='/blog'>Blog</NavLink></li>
            <li><NavLink exact className={({ isActive }) => isActive ? 'current' : ''} to='/news'>News</NavLink></li>
            <li><a href="https://iocdf.org/ocd-finding-help/how-to-find-the-right-therapist/" target='_blank'>Find Help</a></li>
            <li><NavLink exact className={({ isActive }) => isActive ? 'current' : ''} to='/resources'>Resources</NavLink></li>
          </ul>

        </div>
        <div className='contact'>
          <button><a href="/contact_form">Contact</a></button>
          <button><a href="https://www.paypal.com/donate/?hosted_button_id=GF2G4HKW6ANRA" target='_blank'>Donate</a></button>
          <button><a href="/involved">Get Involved</a></button>
        </div>

      </div>

    </div>
    {/* <div id="ocd-event-banner" class="ocd-event-banner">
        <p class="ocd-event-title">
          <strong class="ocd-event-alert">New Event Alert!</strong> <a href='/events'>click here</a> to learn more.
        </p>
        <p>
        Conference Scholarship opportunity for residents of NEW YORK STATE. <a href='/scholarship'>click here</a> to learn more.
        </p>
    </div> */}
    </>
  
  );
}

export default Header;
